export default "__VITE_ASSET__DdzA54NE__"